import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CampaignDetailCard = _resolveComponent("CampaignDetailCard")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "flex justify-center m-2"
    }, [
      _createVNode(_component_CampaignDetailCard, {
        detail: detail,
        class: "sm:w-6/12 text-center mb-2"
      }, null, 8, ["detail"])
    ]))
  }), 128))
}